import { SourcesOfIncome } from 'modules/onboarding/common/components';

import { useSourcesOfIncome } from '../hooks';
import { PageComponentProps } from '../types';

export const SourcesOfIncomeStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
    files,
    onAddFiles,
    onRemoveFile,
    submitDisabled,
  } = useSourcesOfIncome();

  return (
    <SourcesOfIncome
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
